import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Apartments.css';    
import SlidingGallery from './SlidingGallery';

// Declare the hostawayCalendarWidget property on window
declare global {
  interface Window {
    hostawayCalendarWidget?: (config: any) => void;
  }
}

const Brora: React.FC = () => {
  const images = [
    { url: `${process.env.PUBLIC_URL}/images/Brora/front_door.jpg`, alt: "Brora front door" },
    { url: `${process.env.PUBLIC_URL}/images/Brora/coffee.jpg`, alt: "Brora coffee area" },
    { url: `${process.env.PUBLIC_URL}/images/Brora/kitchen_1.jpg`, alt: "Brora kitchen 1" },
    { url: `${process.env.PUBLIC_URL}/images/Brora/kitchen_2.jpg`, alt: "Brora kitchen 2" },
    { url: `${process.env.PUBLIC_URL}/images/Brora/hall.jpg`, alt: "Brora hall" },
    { url: `${process.env.PUBLIC_URL}/images/Brora/bed.jpg`, alt: "Brora bedroom" },
    { url: `${process.env.PUBLIC_URL}/images/Brora/living_room.jpg`, alt: "Brora living room" },
  ];

  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    // Load the calendar script
    const script = document.createElement('script');
    script.src = 'https://d2q3n06xhbi0am.cloudfront.net/calendar.js';
    script.async = true;
    script.onload = () => {
      if (window.hostawayCalendarWidget) {
        window.hostawayCalendarWidget({
          baseUrl: 'https://119528_1.holidayfuture.com/',
          listingId: 419129,
          numberOfMonths: 2,
          openInNewTab: true,
          font: 'Open Sans',
          rounded: true,
          button: {
            action: 'checkout',
            text: 'Book now',
          },
          clearButtonText: 'Clear dates',
          color: {
            mainColor: '#666699',
            frameColor: '#000000',
            textColor: 'green',
          },
        });
      }
    };
    document.head.appendChild(script);
  }, []);

  return (
    <div className="location-container" style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
      <div className="location-content side-by-side-layout">
        <div className="image-section">
          <img 
            src={`${process.env.PUBLIC_URL}/images/Brora/living_room.jpg`} 
            alt="Brora living room" 
            width="400" 
            height="500" 
          />
        </div>

        <div className="content-section">
          <h3>Brora Apartment</h3>
          <h3>Stylish First-Floor One Bedroom Apartment</h3>
          
          <p>
            Brora is a beautifully appointed <strong>one bedroom apartment</strong> located on the <strong>first floor</strong>, 
            offering the ideal balance of space, comfort, and flexibility.
          </p>

          <p>
            The bedroom features both a <strong>double bed and a single bed</strong>, making it perfectly suited for 
            <strong> single, twin, double, or triple occupancy</strong>. Overlooking a <strong>quiet courtyard</strong>, both the 
            <strong> bedroom and the spacious open-plan kitchen/living area</strong> enjoy a peaceful, private setting — ideal for 
            relaxing after a day of exploring Edinburgh.
          </p>

          <p>
            As you enter, you’re welcomed by a <strong>stylish entrance hallway and boot room</strong>, thoughtfully designed for 
            coats, shoes, and luggage — a practical touch that adds to the apartment’s homely charm.
          </p>

          <p>
            Whether you’re travelling solo, as a couple, or with a friend or child, Brora provides all the comforts of home 
            with the added elegance of a luxury stay.
          </p>

          <div id="hostaway-calendar-widget"></div>
          <p><strong>Can't find availability for the dates you're looking for? Try our sister apartments <Link to="/cairn">Cairn</Link> or <Link to="/kinloch">Kinloch</Link> at the same location!</strong></p>

          <div className="slider-wrapper">
            <SlidingGallery 
              images={images} 
              currentSlide={currentSlide} 
              onSlideChange={setCurrentSlide} 
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Brora;
